import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TooltipService {
  // holds the id of the currently open tooltip/menu
  private _currentOpen$ = new BehaviorSubject<string | null>(null);

  public readonly currentOpen$ = this._currentOpen$.asObservable();

  open(id: string) {
    this._currentOpen$.next(id);
  }

  close() {
    this._currentOpen$.next(null);
  }

  toggle(id: string) {
    const current = this._currentOpen$.getValue();
    if (current === id) {
      this.close();
    } else {
      this.open(id);
    }
  }

  getCurrent() {
    return this._currentOpen$.getValue();
  }
}
